// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_1S7Ot","streams":"_2Dkv4","streamsUrl":"_23sk4","embed":"_2AaSc","embedIframeWrapper":"_1WAGh","embedIframe":"i_TtP"};